import React, { CSSProperties } from "react";

interface RootContainerExportProps {
  children?: React.ReactNode;
}

export const RootContainerExport: React.FC<RootContainerExportProps> = ({ children }) => {
  const style: CSSProperties = {
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
  };

  return (
    <div style={style} className="root-container">
      {children}
    </div>
  );
};
